<template>
  <div id="bgContainer" class="login-container" :class="{ 'bg-fade-out': bgFadeOut }" :style="styleObject">

    <!-- PC端显示 -->
    <div v-if="!isPhone" class="login-wrapper">

      <!-- 登录卡片 -->
      <div class="login-card glass scale-in" :class="{ 'blue-theme': parseInt(app_id) === 1 }">

        <!-- 标题区域 -->
        <div class="login-header">
          <div class="login-title">
            <span class="title-text">用户登录</span>
            <div class="title-underline"></div>
          </div>
          <div class="login-subtitle">欢迎回来，请选择登录方式</div>
        </div>

        <!-- 手机验证码方式登录 -->
        <div v-if="phoneLogin" class="login-form fade-in">

          <!-- 手机号登录表单 -->
          <div v-if="changeButton === '统一身份认证账号登陆'" class="form-group">
            <label class="form-label">
              <i class="el-icon-mobile-phone label-icon"></i>
              <span>请输入手机号</span>
            </label>
            <el-input
              v-model.number="phone"
              placeholder="请输入手机号"
              class="form-input"
              prefix-icon="el-icon-mobile-phone">
            </el-input>
          </div>

          <!-- 验证码输入 -->
          <div v-if="changeButton === '统一身份认证账号登陆'" class="form-group">
            <label class="form-label">
              <i class="el-icon-message label-icon"></i>
              <span>请输入验证码</span>
            </label>
            <div class="code-input-wrapper">
              <el-input
                v-model.number="checkCode"
                placeholder="请输入验证码"
                class="form-input code-input"
                prefix-icon="el-icon-key">
              </el-input>
              <el-button
                :type="butType"
                :disabled="!timeTrue"
                @click="acquire"
                class="code-button">
                {{ timeTrue ? '获取验证码' : time + '秒后重新获取' }}
              </el-button>
            </div>
          </div>

          <!-- 统一身份认证账号登录表单 -->
          <div v-if="changeButton === '手机号验证码登录'" class="form-group">
            <label class="form-label">
              <i class="el-icon-user label-icon"></i>
              <span>请输入统一身份认证账号</span>
            </label>
            <el-input
              v-model="userName"
              placeholder="请输入账号"
              class="form-input"
              prefix-icon="el-icon-user">
            </el-input>
          </div>

          <!-- 密码输入 -->
          <div v-if="changeButton === '手机号验证码登录'" class="form-group">
            <label class="form-label">
              <i class="el-icon-lock label-icon"></i>
              <span>请输入密码</span>
            </label>
            <el-input
              v-model="passWord"
              type="password"
              placeholder="请输入密码"
              class="form-input"
              prefix-icon="el-icon-lock"
              show-password>
            </el-input>
          </div>

          <!-- 登录按钮 -->
          <el-button
            class="login-button"
            :type="butType"
            @click="login">
            <span class="button-text">登录</span>
          </el-button>

          <!-- 切换登录方式 -->
          <el-button
            type="text"
            class="switch-button"
            :disabled="change"
            @click="changeButtonText">
            <span class="switch-text">{{ changeButton }}</span>
          </el-button>

        </div>

        <!-- 扫码登录 -->
        <div v-if="!phoneLogin" class="qr-login fade-in">
          <div v-if="showPromptTxt" class="qr-prompt">
            <i class="el-icon-loading"></i>
            <span>已扫码，请在手机上点击确认</span>
          </div>

          <el-image
            v-if="showCode"
            class="qr-code"
            :src="qrCodeUrl"
            fit="contain">
            <div slot="error" class="image-slot">
              <div class="loading-spinner"></div>
            </div>
          </el-image>

          <el-result
            v-if="!showCode"
            icon="warning"
            title="二维码已经过期"
            subTitle="请刷新二维码">
            <template slot="extra">
              <el-button :type="butType" size="medium" @click="updateCode" class="refresh-button">
                <i class="el-icon-refresh"></i>
                刷新
              </el-button>
            </template>
          </el-result>
        </div>

        <!-- 切换登录方式按钮 -->
        <el-button
          @click="changeLogIn()"
          class="toggle-login-button"
          :type="butType">
          <i :class="phoneLogin ? 'el-icon-qr-code' : 'el-icon-mobile-phone'"></i>
          <span>{{ buttonIcon }}</span>
        </el-button>

      </div>

    </div>

    <!-- 手机端显示登录框 -->
    <div v-if="isPhone" class="mobile-login-wrapper">
      <div class="mobile-login-card glass">
        <div class="mobile-login-header">
          <div class="mobile-login-title">统一身份认证</div>
          <div class="mobile-login-subtitle">请暂时从PC端访问</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import * as clientUtils from "@/axios/ClientUtils";
import {isMobile} from 'react-device-detect';
import {AestheticFluidBg} from '../appList/build/jsm/AestheticFluidBg.module.js'
var timer
export default {
  name: "userLogIn",
  data() {
    return {
      butType:'',

      //验证码按钮数据
      timeTrue: true,
      time: 0,

      //是否是手机
      isPhone: '',

      //是否是手机号登陆，false是扫码登陆
      phoneLogin: true,
      buttonIcon: '扫码授权登录',

      app_id: 2,
      qrCodeUrl: '',
      scene: '',
      showPromptTxt: false,
      //是否展示二维码
      showCode:true,

      //  手机号验证码登录
      phone: '',
      checkCode: '',

      styleObject:{
        height: '100vh',
        backgroundImage: '',
        backgroundSize:'cover'
      },

      changeButton:"统一身份认证账号登陆",
      userName:"",
      passWord:"",
      change:false,


      // 背景图列表
      backgroundImages: [
        "https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/service_zhcp/2026/1/18/8471e59c-f1cc-4f0d-bb7c-50ecb6a8927e.jpeg",
        "https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/service_zhcp/2026/1/18/e60d3ae1-ed0d-42da-9d01-c173bbcf8629.jpeg",
        "https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/service_zhcp/2026/1/18/b5a0e791-0db6-496b-9c81-1ae4199243eb.jpeg",
        "https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/service_zhcp/2026/1/18/947c4a78-330a-4f6c-bf15-4a93ebe29944.jpeg",
        "https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/service_zhcp/2026/1/18/eb191895-5db8-4df4-9b8a-115869edc11c.jpeg",
        "https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/service_zhcp/2026/1/18/5a3cbe27-1f7a-4d34-8368-87d3187279a1.jpeg",
        "https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/service_zhcp/2026/1/18/ccfebb58-1c26-4a6a-a7c2-96bc7a59d41d.jpeg",
        "https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/service_zhcp/2026/1/18/f862c6ba-c2da-4b8a-973a-38b98719e858.jpeg",
        "https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/service_zhcp/2026/1/18/2e687c78-9832-4268-9291-4c8c53c57334.jpeg",
        "https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/service_zhcp/2026/1/18/3ba24b36-90d5-4821-be94-abeb281cde17.jpeg",
        "https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/service_zhcp/2026/1/18/663e2e0a-cadc-46a9-a4cf-38cb60219ea6.jpeg",
        "https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/service_zhcp/2026/1/18/7193ee6a-c756-416e-bc9d-5cd9ac2c66f6.jpeg",
        "https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/service_zhcp/2026/1/18/60ee2c6f-5372-4eba-a020-42c7f0bba8b9.jpeg",
        "https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/service_zhcp/2026/1/18/770289bc-b7d0-4f4e-8da4-82a53214bb14.jpeg",
        "https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/service_zhcp/2026/1/18/8e910357-1052-43a3-a0db-f8e640eca9eb.jpeg",
        "https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/service_zhcp/2026/1/18/bd3ad052-ddca-40cc-9060-17fc65e84b3b.jpeg",
        "https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/service_zhcp/2026/1/18/59c5eb63-ccd4-4084-b167-9088afd62649.jpeg",
        "https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/service_zhcp/2026/1/18/d612ec7e-f9ac-4063-b218-2e561d06340a.jpeg",
        "https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/service_zhcp/2026/1/18/0e040cbe-5d59-4fc4-88f6-0b97bad608c6.jpeg",
        "https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/service_zhcp/2026/1/18/df1855a5-87ac-4a3d-b886-6676e31926bc.jpeg",
        "https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/service_zhcp/2026/1/18/a896f47a-c298-41ba-9c44-6c2e0d0a0a60.jpeg",
        "https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/service_zhcp/2026/1/18/8aa6a0c3-8c70-45cd-b2ad-4e8ebb8baccb.jpeg",
        "https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/service_zhcp/2026/1/18/d48d7394-4028-43fe-ae3c-bcf83c85359e.jpeg",
        "https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/service_zhcp/2026/1/18/5b70f37d-5ff2-4a72-9aed-4ba5d33ceb67.jpeg",
      ],
      // 当前背景图索引
      currentBgIndex: 0,
      // 背景图切换定时器
      bgTimer: null,
      // 背景图淡入淡出动画
      bgFadeOut: false
    }
  },
  activated() {
    this.app_id = localStorage.getItem('app_id')

    //代表是手机上的，显示手机的背景图,else则是pc模式，自动填入电脑背景图
    if (this.isPhone){
      //todo 这三张图需要链接
      if (parseInt(this.app_id) === 1){
        // 启动背景图轮播
        this.startBgSlideshow()
        this.butType = 'success'
        this.change = true
      }else if (parseInt(this.app_id) === 2){
        this.styleObject.backgroundImage = 'url("https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/assests/dhd/background/web/bg.jpg")'
        this.butType = 'primary'
        this.change = false
      }else if (parseInt(this.app_id) === 3){
        this.styleObject.backgroundImage = 'url("https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/assests/lnzy/background/web/bg.jpg")'
        this.butType = 'danger'
        this.change = true
      }else if (parseInt(this.app_id) === 4){
        this.styleObject.backgroundImage = 'url("https://www.lnxdfwxy.com/__local/3/0D/89/DA8EA5534105C71C7C2E466985D_FD86E4A6_96C85.png?e=.png")'
        this.butType = 'danger'
        this.change = true
      } else if (parseInt(this.app_id) === 5){
        this.styleObject.backgroundImage = 'url("https://moyo-web-v2-prod.bj.bcebos.com/talk/20160104095919330750.jpg")'
        this.butType = 'danger'
        this.change = true
      }else if (parseInt(this.app_id) === 6){
        this.styleObject.backgroundImage = 'url("https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/assests/dhd/background/web/bg.jpg")'
        this.butType = 'primary'
        this.change = false
      } else if (parseInt(this.app_id) === 7) {
        setTimeout(function () {
          new AestheticFluidBg({
            dom: "bgContainer",
            colors: ["#007FFE", "#3099FE", "#60B2FE", "#90CCFE", "#C0E5FE", "#F0FFFE"],
            seed: 1000,
            loop: true
          })
        }, 200)
      }

    }else {


      //todo 沈阳师范的需要链接
      if (parseInt(this.app_id) === 1){
        // 启动背景图轮播
        this.startBgSlideshow()
        this.butType = 'success'
        this.change = true
      }else if (parseInt(this.app_id) === 2){
        this.styleObject.backgroundImage = 'url("https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/assests/dhd/background/web/bg.jpg")'
        this.butType = 'primary'
        this.change = false
      }else if (parseInt(this.app_id) === 3){
        this.styleObject.backgroundImage = 'url("https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/assests/lnzy/background/web/bg.jpg")'
        this.butType = 'danger'
        this.change = true
      }else if (parseInt(this.app_id) === 4){
        this.styleObject.backgroundImage = 'url("https://www.lnxdfwxy.com/__local/3/0D/89/DA8EA5534105C71C7C2E466985D_FD86E4A6_96C85.png?e=.png")'
        this.butType = 'danger'
        this.change = true
      }else if (parseInt(this.app_id) === 5){
        this.styleObject.backgroundImage = 'url("https://moyo-web-v2-prod.bj.bcebos.com/talk/20160104095919330750.jpg")'
        this.butType = 'danger'
        this.change = true
      }else if (parseInt(this.app_id) === 6){
        this.styleObject.backgroundImage = 'url("https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/assests/dhd/background/web/bg.jpg")'
        this.butType = 'primary'
        this.change = false
      } else if (parseInt(this.app_id) === 7) {
        setTimeout(function () {
          new AestheticFluidBg({
            dom: "bgContainer",
            colors: ["#007FFE", "#3099FE", "#60B2FE", "#90CCFE", "#C0E5FE", "#F0FFFE"],
            seed: 1000,
            loop: true
          })
        }, 200)
      }
    }


    if (!this.phoneLogin){
      this.getQRcode()
      this.showPromptTxt = false
    }

  },
  methods: {

    // 启动背景图轮播
    startBgSlideshow() {
      // 清除之前的定时器
      if (this.bgTimer) {
        clearInterval(this.bgTimer)
      }
      // 设置初始背景图
      this.styleObject.backgroundImage = `url("${this.backgroundImages[0]}")`
      // 每10秒切换一次背景图
      this.bgTimer = setInterval(() => {
        this.switchBackground()
      }, 30000)
    },

    // 切换背景图（带淡入淡出动画）
    switchBackground() {
      // 淡出
      this.bgFadeOut = true
      setTimeout(() => {
        // 切换到下一张图片
        this.currentBgIndex = (this.currentBgIndex + 1) % this.backgroundImages.length
        this.styleObject.backgroundImage = `url("${this.backgroundImages[this.currentBgIndex]}")`
        // 淡入
        this.bgFadeOut = false
      }, 500) // 500ms淡出时间
    },

    // 停止背景图轮播
    stopBgSlideshow() {
      if (this.bgTimer) {
        clearInterval(this.bgTimer)
        this.bgTimer = null
      }
    },

    //手机号验证码登录和学工系统账号登录切换按钮
    changeButtonText(){
      if(this.changeButton === '手机号验证码登录'){
        this.changeButton = '统一身份认证账号登陆'
      }else {
        this.changeButton = '手机号验证码登录'
      }

    },

    //获取二维码
    getQRcode() {

      const that = this
      var myHeaders = new Headers();
      myHeaders.append("app-id", this.app_id);

      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch("https://loginv2.timkj.cn/autoLogin/v2/pub/wechat/miniApp/getQrCode", requestOptions)
          .then(response => response.json())
          .then(function (result) {
            console.log(result)
            that.qrCodeUrl = "data:image/jpeg;base64," + result.data.qr
            that.scene = result.data.scene
            let num = 0
            timer =  setInterval(function () {
              console.log(num)
              if (num <= 20){
                num++
              }else {
                console.log("达到轮询次数")
                num = 0
                that.showCode=false
                that.showPromptTxt = false
                clearInterval(timer)
              }
              that.checkCodeState(timer)
            }, 3000)

          })
          .catch(error => console.log('error', error));
    },

    //刷新二维码
    updateCode(){
      this.qrCodeUrl = ""
      this.showCode = true
      this.showPromptTxt = false
      this.getQRcode()
    },

    //检查二维码状态
    checkCodeState(timer) {
      const that = this

      var myHeaders = new Headers();

      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch("https://loginv2.timkj.cn/autoLogin/v2/pub/wechat/miniApp/checkQrCodeState?scene=" + this.scene, requestOptions)
          .then(response => response.json())
          .then(function (result) {
            console.log(result)
            if (result.data.state === 2) {
              console.log('已扫描')
              that.showPromptTxt = true
            } else if (result.data.state === 3) {
              console.log("成功授权")
              that.showPromptTxt = false
              localStorage.setItem('app_id', that.app_id)
              localStorage.setItem("token",result.data.access_token)
              clearInterval(timer);
              that.$router.replace("AppListPC")
            }

          })
          .catch(error => console.log('error', error));
    },

    //切换扫码/验证码方式登录
    changeLogIn() {

      if (this.phoneLogin) {
        this.phoneLogin = false
        this.buttonIcon = '手机号验证码登录'
        this.getQRcode()
      } else {
        this.phoneLogin = true
        this.buttonIcon = '扫码授权登录'
        console.log("清除定时器")
        this.showPromptTxt = false
        clearInterval(timer);
      }

    },

    //获取验证码方法
    acquire() {
      var myreg = /^1[3-9]\d{9}$/;
      if (!myreg.test(this.phone)) {
        this.$notify.error({
          title: '手机号不合法',
          message: ''
        });
        this.phone = ''
      } else {


        const requestOptions = {
          method: "GET",
          redirect: "follow"
        };
        const that = this


        fetch("https://dhdpoverty.api.timkj.cn/test/verifyCode?phone="+ this.phone, requestOptions)
            .then((response) => response.json())
            .then(function (result) {
              if (result.code === 0) {
                that.$notify.success({
                  title: '验证码成功发送',
                  message: ''
                });

                that.timeTrue = false;
                that.time = 60;
                //定时器倒数时间
                var setTimeoutS = setInterval(() => {
                  that.time--;
                  if (that.time <= 0) {
                    clearInterval(setTimeoutS);
                    that.timeTrue = true;
                  }
                }, 1000);
              } else {
                that.$notify.error({
                  title: '验证码发送失败',
                  message: result.msg
                });
              }
            })
            .catch((error) => console.error(error));

      }


    },

    //手机验证码方式登录方法
    login() {

      if (this.changeButton === '统一身份认证账号登陆'){

        if (this.phone === "" || this.checkCode === "") {
          this.$notify.error({
            title: '请输入手机号及验证码',
            message: ''
          });
        } else {
          const that = this
          clientUtils.post("autoLogin/v2/pub/auth/login/phoneAndVerifyCode", {phone: this.phone, verify_code: this.checkCode}, function (res) {

            if (res.data.code === 0){
              console.log(res.data.data.access_token)

              let token = res.data.data.access_token
              localStorage.setItem("token",token)
              if (that.isPhone){
                // that.$router.replace('AppListMobile')
                that.$notify.error({
                  title: '请暂时从PC端访问',
                  message: ""
                });
              }else {
                that.$router.replace('AppListPC')
              }

            }else {
              that.$notify.error({
                title: '登录失败',
                message: res.data.error_msg
              });
            }
          })
        }
      }else {
        if (this.userName === '' || this.passWord === ''){
          this.$notify.error({
            title: '请输入统一身份认证账号及密码',
            message: ''
          });
        }else {
          let obj = {
            "type": 1,
            "username":this.userName,
            "password":this.passWord
          }
          const that = this
          clientUtils.post("/autoLogin/v2/pub/auth/login/thirdAuth",obj,function (res){
            if (res.data.code ===0){
              console.log(res)
              let token = res.data.data
              localStorage.setItem("token",token)
              that.$router.replace('AppListPC')
            }else {
              that.$notify.error({
                title:res.data.msg,
                message:res.data.data
              })

            }
          })
        }
      }

    }

  },
  mounted() {
    this.isPhone = isMobile
  },
  beforeDestroy() {
    // 组件销毁前清除背景图轮播定时器
    this.stopBgSlideshow()
  }

}
</script>

<style scoped lang="scss">
// 登录容器
.login-container {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  transition: opacity 0.5s ease-in-out;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.1);
    z-index: 1;
  }

  &.bg-fade-out {
    opacity: 0;
  }
}

// 登录包装器
.login-wrapper {
  position: relative;
  z-index: 10;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 0 10%;
}

// 登录卡片
.login-card {
  min-height: 550px;
  width: 420px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 30px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.5);
}

// 登录头部
.login-header {
  width: 100%;
  margin-bottom: 30px;
  text-align: center;
}

.login-title {
  margin-bottom: 8px;
}

.title-text {
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(135deg, #586cb1 0%, #7a8bc9 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.title-underline {
  width: 60px;
  height: 4px;
  background: linear-gradient(90deg, #586cb1, #7a8bc9);
  margin: 12px auto 0;
  border-radius: 2px;
}

.login-subtitle {
  font-size: 14px;
  color: #909399;
  margin-top: 12px;
}

// 登录表单
.login-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 320px;
}

// 表单组
.form-group {
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
}

.form-label {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
  font-weight: 500;
}

.label-icon {
  margin-right: 6px;
  color: #586cb1;
}

.form-input {
  width: 100%;

  ::v-deep .el-input__inner {
    height: 44px;
    border-radius: 12px;
    border: 1px solid #dcdfe6;
    font-size: 15px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      border-color: #7a8bc9;
    }

    &:focus {
      border-color: #586cb1;
      box-shadow: 0 0 0 3px rgba(88, 108, 177, 0.1);
    }
  }
}

// 验证码输入包装器
.code-input-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.code-input {
  flex: 1;
}

.code-button {
  height: 44px;
  padding: 0 16px;
  border-radius: 12px;
  font-size: 14px;
  white-space: nowrap;
  background: linear-gradient(135deg, #586cb1 0%, #485faf 100%);
  border: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover:not(:disabled) {
    background: linear-gradient(135deg, #7a8bc9 0%, #586cb1 100%);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(88, 108, 177, 0.3);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

// 登录按钮
.login-button {
  width: 100%;
  height: 48px;
  margin-top: 30px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  border: none;
  background: linear-gradient(135deg, #586cb1 0%, #485faf 100%);
  box-shadow: 0 4px 16px rgba(88, 108, 177, 0.3);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s;
  }

  &:hover {
    background: linear-gradient(135deg, #7a8bc9 0%, #586cb1 100%);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(88, 108, 177, 0.4);

    &::before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(0);
  }
}

// 切换按钮
.switch-button {
  margin-top: 16px;
  font-size: 14px;
  color: #909399;
  transition: all 0.3s;

  &:hover:not(:disabled) {
    color: #586cb1;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.switch-text {
  text-decoration: underline;
  text-underline-offset: 2px;
}

// 二维码登录
.qr-login {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 280px;
}

.qr-prompt {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: #586cb1;
  font-size: 15px;
  margin-bottom: 20px;

  i {
    font-size: 24px;
    animation: rotate 2s linear infinite;
  }
}

.qr-code {
  width: 280px;
  height: 280px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;

  &:hover {
    transform: scale(1.02);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
  }
}

.image-slot {
  width: 280px;
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
}

.refresh-button {
  padding: 10px 24px;
  border-radius: 12px;
  font-weight: 500;
}

// 切换登录方式按钮
.toggle-login-button {
  margin-top: 40px;
  padding: 12px 32px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 500;
  background: linear-gradient(135deg, #586cb1 0%, #485faf 100%);
  border: none;
  color: white;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(88, 108, 177, 0.25);

  &:hover {
    background: linear-gradient(135deg, #7a8bc9 0%, #586cb1 100%);
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(88, 108, 177, 0.35);
  }

  i {
    font-size: 18px;
  }
}

// 移动端登录
.mobile-login-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.mobile-login-card {
  width: 100%;
  max-width: 320px;
  min-height: 300px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 24px;
  padding: 40px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

.mobile-login-header {
  text-align: center;
}

.mobile-login-title {
  font-size: 24px;
  font-weight: 700;
  background: linear-gradient(135deg, #586cb1 0%, #7a8bc9 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 12px;
}

.mobile-login-subtitle {
  font-size: 14px;
  color: #909399;
}

// 动画
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.fade-in {
  animation: fadeIn 0.4s ease-out;
}

.scale-in {
  animation: scaleIn 0.5s ease-out;
}

// 加载动画
.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(88, 108, 177, 0.15);
  border-top-color: #586cb1;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

// 玻璃态效果
.glass {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.6);
}

// 响应式设计
@media (max-width: 768px) {
  .login-wrapper {
    padding: 0 20px;
    justify-content: center;
  }

  .login-card {
    width: 100%;
    min-height: 480px;
    padding: 30px 20px;
  }

  .title-text {
    font-size: 24px;
  }

  .form-input {
    ::v-deep .el-input__inner {
      height: 40px;
      font-size: 14px;
    }
  }

  .code-button {
    height: 40px;
    padding: 0 12px;
    font-size: 13px;
  }

  .login-button {
    height: 44px;
    font-size: 15px;
  }

  .qr-code {
    width: 240px;
    height: 240px;
  }
}
</style>
